import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import './SpecialPageContainer.scss';

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

export function mapProps() {
    return;
}

export function mapDispatch() {
    return;
}

export class SpecialPageContainer extends React.Component<RouteProps, {}> {

    render() {
        return (
            <div className='special-page-container'>
                <div style={{paddingBottom: 75}}>
                    <div className='special-page-container__header'>
                        Газпромбанк Мобайл
                    </div>
                    <img src='https://konsierge.com/files/1125_600_black11.png' />
                    <div className='special-page-container__body'>
                        <h2>
                            Премиум клиенты не&nbsp;платят за&nbsp;связь
                        </h2>
                        <div>
                            <div>
                                Два&nbsp;шага для&nbsp;бесплатной связи:
                            </div>
                            <ol>
                                <li>Оформите сим-карту Газпромбанк&nbsp;Мобайл с&nbsp;тарифом «Движение» (20 ГБ, 600 минут) и&nbsp;ежемесячной оплатой.</li>
                                <li>Подключите номер к&nbsp;программе лояльности «Быть&nbsp;вместе» в&nbsp;приложении Банка.</li>
                            </ol>
                        </div>
                        <br/>
                        <div className='special-page-container__offer'>
                            <b>100%</b> скидка на&nbsp;абонентскую плату подключится не&nbsp;позднее 7&nbsp;календарных дней.
                        </div>
                    </div>
                </div>
                <div className='special-page-container__button'>
                    <button onClick={() => location.href = 'https://gpbmobile.ru/gpb-premium?utm_source=gazprombank&utm_medium=mobile&utm_campaign=premium_concierge&utm_content=premium_concierge'}>
                        Заказать сим-карту
                    </button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/GPBMobile/SpecialPageContainer.tsx